module.exports = __webpack_public_path__ + "static/media/pdf.3fa92281.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pdf.svg
// module id = 17
// module chunks = 0